import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { CasesExportState, CasesExportStatus } from './types';

const initialState: CasesExportState = {
  file: null,
  formValues: null,
  status: CasesExportStatus.Initial,
};

const casesExportSlice = createSlice({
  initialState,
  name: 'casesExport',
  reducers: {
    reset: () => initialState,
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    fileProcessed: (state, action) => {
      state.status = CasesExportStatus.Ready;
      state.file = action.payload;
    },
    setFormValues: (state, action) => {
      state.formValues = {
        ...state.formValues,
        ...action.payload,
      };
    },
  },
});

const {
  reducer: casesExportReducer,
  actions: { reset, setStatus, fileProcessed, setFormValues },
} = casesExportSlice;

const selectCasesExport = (state: RootState) => state.casesExport;

export {
  reset,
  setStatus,
  fileProcessed,
  setFormValues,
  CasesExportStatus,
  selectCasesExport,
  casesExportReducer,
};

export type { CasesExportState };
